import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ErrorContent from '../components/Error';

// Used both as the catch-all 404 (mode="notfound") and the
// "/under-construction" route (mode="construction") — see app/App.js.
const Error = ({ mode = "notfound" }) => {
    return (
        <>
            <Header topbarEnable="enable" />
            <ErrorContent mode={mode} />
            <Footer />
        </>
    );
}


export default Error;

